import { useEffect } from 'react';
import { useI18n } from '~Hooks';
import { MethodProps } from '../types';
import { v4 as uuid } from 'uuid';

interface Props {
  payment: any;
  onComplete: () => void;
  onFail: (message: string) => void;
  fail?: boolean;
}

const TimeuotPayment: React.FunctionComponent<MethodProps & {
  fail?: boolean;
}> = ({ payment, onComplete, onFail, fail = false }) => {
  const { i18n } = useI18n();

  useEffect(() => {
    const handlePayment = () => {
      if (fail) {
        onFail(i18n('Timeout.Failure'));
      } else {
        onComplete(null, {
          transactionId: uuid(),
        });
      }
    };

    if (payment.method === 'PAY_LATER') {
      return handlePayment();
    }

    setTimeout(handlePayment, 2500);
  }, []);

  return null;
};

export default TimeuotPayment;
